import { useEffect, useRef, useState } from 'react'
import { Contact, ConversationCardModel, mapToContactType } from '../../models/conversations'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Tooltip } from '@mui/material';
import Avatar from '../shared/avatar.component';
import { UtilityService } from '../../services/UtilityService';
import GroupChatContactList from "../shared/group-contact-list.component";
import ButtonComponent from '../shared/button/button.component';
import { ActionLabels, ToasterTexts, appNote, buttonLabels, pageTitles } from '../shared/constants';
import { ArchivedIcon, BackMobileIcon, CancelIcon, DownloadChatIcon, MarkasReadIcon, MarkasUnreadIcon, MuteIcon, PinIcon, SettingsVertiMobileIcon, TrashIcon, UnArchivedIcon, UnMuteIcon, UnpicIcon, OutGoingCallIcon, CampainMsgHistoryEditIcon, CampainNewIcon, RefreshIcon, TransforChatIcon, ImportContactIcon, BlackRefreshIcon } from '../../icon';
import ContactInfoComponent from './contact-info.component';
import ContactView from "../contacts/contact-view.component";
import ConfirmDialog from '../shared/confirm-dialog.component';
import setToast from '../../helpers/toaster.helper';
import { ContactService } from '../../services/ContactService';
import { ToasterType } from '../shared/toaster/toaster.model';
import { clearContactStatusHirtory, LoadMessages, MuteConversation, UpdateContactTypes, UpdateHistory } from '../../actions';
import { MessageService } from '../../services/MessageService';
import { MenuItemRender } from '../shared/menu-item-render';
import { SettingsService } from '../../services/SettingsService';
import GroupChatViewComponent from './groupchat-view.component';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"
import { useDispatch } from 'react-redux'
import * as microsoftTeams from '@microsoft/teams-js';
import GroupchatIcon from "../../icons/group-chat-avator-icon.svg";
import AssignAndStatus from './AssignAndStatus';
import { UserModel } from '../../models/users.model';
import { useNavigate, useParams } from 'react-router';
import { AppRoutes } from '../routes/route.path';
import TransferConversationChat from './transfor-chat';
import { PlanMetrics, UserPlanTracker } from '../../models/plan-metrics.model';

interface Props {
    CardData: ConversationCardModel;
    ActiveCardIndex: number;
    BackHandler: () => void
    HandelContactInfomobile: (x: boolean) => void;
    HandelTransferChatfomobile: (x: boolean) => void;
    ActionsData?: any;
    IsSecureChat?: boolean;
    onOpenContactInfo?: (data?: any) => void;
    onCloseContactInfo?: () => void;

}

const ConversationHistoryHeader = (props: Props) => {
    const dispatch = useDispatch()
    const params = useParams();
    const navigate = useNavigate()
    const Contacts: Contact[] = useSelector(selector.contacts)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const Users: UserModel[] = useSelector(selector.users);
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics);
    const UserPlanTracker: UserPlanTracker = useSelector(selector.userPlanTracker);
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow);


    const { Contact, PhoneNumber, GroupChat, MaskedPhoneNumber, IsBlocked, Campaign, msgType } = props.CardData;
    const [showContactInfo, setShowContactInfo] = useState<boolean>(false)
    const [openEditContact, setOpenEditContact] = useState<boolean>(false)
    const [isloading, setIsLoading] = useState<boolean>(false);
    const [showMuteForm, setShowMuteForm] = useState<boolean>(false)
    const [muteDuration, setMuteDuration] = useState<number>(1)
    const [showDeleteHistoryDialog, setShowDeleteHistoryDialog] = useState<boolean>(false)
    const [openEditGroupChatName, setOpenEditGroupChatName] = useState<boolean>(false)
    const [IsTransferConversationChat, setTransferConversationChat] = useState<boolean>(false)

    const statusPopoverJustClosedRef = useRef(false);

    const openContactInfo = (e) => {
        if (IsMobileDevice && statusPopoverJustClosedRef.current) {
            statusPopoverJustClosedRef.current = false;
            return;
        }
        if (IsMobileDevice) {
            props.HandelContactInfomobile(true)
        }
        else {
            // setShowContactInfo(true)
            props.onOpenContactInfo({
                Contact,
                PhoneNumber,
                MaskedPhoneNumber,
                GroupChat,
                Campaign,
            });
        }
    }

    const openTransferChat = () => {
        if (IsMobileDevice) {
            props.HandelTransferChatfomobile(true)
        }
    }

    const closeContactInfo = () => {
        // setShowContactInfo(null)
        props.onCloseContactInfo()
    }

    const handleEditContact = () => {
        setShowContactInfo(false)
        setOpenEditContact(true)
    }

    const closeEditContact = () => {
        setOpenEditContact(false)

    }

    useEffect(() => {
        closeContactInfo()
    }, [props.CardData.PhoneNumber])


    //mobile menu action 

    const handelArchive = (phoneNumber: string, archived: boolean, groupChatId: string) => {
        let archiveChat = groupChatId ? groupChatId : phoneNumber
        return MessageService.setContactAsArchived(archiveChat, !archived).then(res => {
            setToast(archived ? ToasterTexts.UNARCHIVE_SUCCESS : ToasterTexts.ARCHIVE_SUCCESS, ToasterType.SUCCESS)
            UpdateContactTypes(dispatch, res.map(mapToContactType))
        });
    }

    const handelPin = (phoneNumber: string, pinned: boolean, groupChatId: string) => {
        let pinnedChat = groupChatId ? groupChatId : phoneNumber
        MessageService.setContactAsPinned(pinnedChat, !pinned).then(res => {
            setToast(pinned ? ToasterTexts.UNPIN_SUCCES : ToasterTexts.PIN_SUCCESS, ToasterType.SUCCESS)
            UpdateContactTypes(dispatch, res.map(mapToContactType));
        }, (error) => {
            if (error?.response?.status === 400) {
                if (error?.response?.data?.code === SettingsService.Pinned_Contacts_Code) {
                    setToast(ToasterTexts.MAXIMUM_PINNED_CONV.replace("<count>", error?.response?.data?.value), ToasterType.DANGER);
                }
                else if (error?.response?.data?.message) {
                    setToast(error?.response?.data?.message, ToasterType.DANGER);
                }
            }
        });
    }

    const muteConversation = (event?: any) => {
        let muteChatName = !!props.CardData.GroupChat ? !!props.CardData.GroupChat?.Name ? UtilityService.trimMessage(props.CardData.GroupChat?.Name, 10) : "Group Chat" : !!props.CardData.Contact?.Name ? UtilityService.trimMessage(props.CardData.Contact?.Name, 10) : props.CardData?.MaskedPhoneNumber;

        MuteConversation(dispatch, props.CardData.GroupChat?.ID ? props.CardData.GroupChat?.ID : props.CardData.PhoneNumber, props.CardData.IsMuted ? 0 : muteDuration).then(res => {
            setToast(props.CardData.IsMuted ? ToasterTexts.UNMUTE_CONVERSATION.replace('<Name>', muteChatName) : ToasterTexts.MUTE_CONVERSATION.replace('<Name>', muteChatName), ToasterType.SUCCESS)

        })
        setShowMuteForm(false)
        setMuteDuration(0);
        event.stopPropagation();
    }

    const closeDeleteHistoryDialog = (isConfim: boolean, event?: any) => {
        event.stopPropagation();
        if (isConfim) {
            setIsLoading(true)
            if (!!props.CardData.GroupChat?.ID) {
                MessageService.deleteGroupChatHistory(props.CardData?.GroupChat?.ID).then(() => {
                    setToast(ToasterTexts.DELETE_SUCCESS, ToasterType.SUCCESS)
                    setIsLoading(false)
                    setShowDeleteHistoryDialog(false)
                });
            } else {
                MessageService.deleteHistory(props.CardData?.PhoneNumber).then(() => {
                    setToast(ToasterTexts.DELETE_SUCCESS, ToasterType.SUCCESS)
                    setIsLoading(false)
                    setShowDeleteHistoryDialog(false)
                });
            }
            LoadMessages(dispatch)
            UpdateHistory(dispatch, (props.CardData?.GroupChat ? props.CardData.GroupChat?.ID : (props.CardData.PhoneNumber.replace('+', ''))), [])
        }
        else {
            setShowDeleteHistoryDialog(false)
        }
    }

    const handelMarkAsRead = (event?: any) => {
        navigate(AppRoutes.CONVERSATIONS)
        if (!!props.CardData.GroupChat?.ID) {
            MessageService.groupChatReadOrUnread(props.CardData.GroupChat?.ID, props.CardData.GroupChat?.UnReadCount > 0 ? 0 : 1).then(() => {
                setToast(props.CardData.GroupChat?.UnReadCount > 0 ? ToasterTexts.MARK_AS_READ_SUCCESS : ToasterTexts.MARK_AS_UNREAD_SUCCESS, ToasterType.SUCCESS)
            })
        }
        else {
            ContactService.setUnreadMessageCount(props.CardData.PhoneNumber, 1 - props.CardData.UnReadCount).then(() => {
                setToast(props.CardData.UnReadCount > 0 ? ToasterTexts.MARK_AS_READ_SUCCESS : ToasterTexts.MARK_AS_UNREAD_SUCCESS, ToasterType.SUCCESS)
            })
        }
    }

    const handeleDownloadChat = () => {
        if (!!props.CardData.GroupChat?.ID) {
            setToast(ToasterTexts.DOWNLOADING_CHAT.replace('<Name>', props.CardData.GroupChat?.Name ? props.CardData.GroupChat?.Name : "Group Chat"), ToasterType.INFO)
            MessageService.downloadGroupChatHistory(props.CardData.GroupChat?.ID).then(res => {
                downloadFile(res.data, props.CardData.GroupChat?.Name ? props.CardData.GroupChat?.Name : "Group Chat")
            })
        }
        else {
            setToast(ToasterTexts.DOWNLOADING_CHAT.replace('<Name>', !!props.CardData.Contact?.Name ? props.CardData.Contact?.Name : UtilityService.maskPhoneNumberOnLength(props.CardData.PhoneNumber)), ToasterType.INFO)
            MessageService.downloadHistoryText(UtilityService.unmaskPhoneNumber(props.CardData.PhoneNumber)).then(res => {
                downloadFile(res.data, !!props.CardData.Contact?.Name ? props.CardData.Contact?.Name : props.CardData.PhoneNumber)
            })
        }
    }

    const downloadFile = (data: any, name: string) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(new Blob([data], {
            type: "application/text"
        }));
        link.setAttribute("download", `Falkon SMS-${name}.txt`);
        link.click();
    }

    const optionData =
        [{
            Name: props.CardData.IsArchived ? ActionLabels.UNARCHIVE : ActionLabels.ARCHIVE,
            Icon: props.CardData.IsArchived ? UnArchivedIcon : ArchivedIcon,
            OnClick: () => handelArchive(props.CardData.PhoneNumber, props.CardData.IsArchived, props.CardData.GroupChat?.ID),
        },
        {
            Name: props.CardData.IsPinned ? ActionLabels.UNPIN : ActionLabels.PIN,
            Icon: props.CardData.IsPinned ? UnpicIcon : PinIcon,
            Hide: props.CardData.IsArchived,
            OnClick: () => handelPin(props.CardData.PhoneNumber, props.CardData.IsPinned, props.CardData.GroupChat?.ID),
        },
        {
            Name: props.CardData.IsMuted ? ActionLabels.UNMUTE : ActionLabels.MUTE,
            Icon: props.CardData.IsMuted ? UnMuteIcon : MuteIcon,
            OnClick: (e) => props.CardData.IsMuted ? muteConversation(e) : setShowMuteForm(true),
            Hide: !!Campaign && Campaign.ID ? true : false
        },
        {
            Name: ActionLabels.DELETE,
            Icon: TrashIcon,
            OnClick: () => setShowDeleteHistoryDialog(true),
        },
        {
            Name: (props.CardData.GroupChat?.UnReadCount || props.CardData.UnReadCount) > 0 ? ActionLabels.MARK_AS_READ : ActionLabels.MARK_AS_UNREAD,
            Icon: (props.CardData.GroupChat?.UnReadCount || props.CardData.UnReadCount) > 0 ? MarkasReadIcon : MarkasUnreadIcon,
            OnClick: (e) => handelMarkAsRead(e),
            Hide: !!Campaign && Campaign.ID ? true : false
        },
        {
            Name: ActionLabels.DOWNLOAD_CHAT,
            Icon: DownloadChatIcon,
            OnClick: () => handeleDownloadChat(),
            Hide: !!Campaign && Campaign.ID ? true : false
        }
        ]

    const MuteOptions = [
        { name: "For 1 hour", value: 1 },
        { name: "For 1 day", value: 24 },
        { name: "Always", value: -1 }
    ];

    const handleEditGroupName = (e) => {
        e.stopPropagation();
        setOpenEditGroupChatName(true)
    }

    const handleCloseEditGroupchatname = () => {
        setOpenEditGroupChatName(false)
    }

    const startCall = (PhoneNumber: string) => {
        if (IsTeamsApp) {
            microsoftTeams.call.startCall({
                targets: [`4:${PhoneNumber}`]
            });
        }
    }

    const handleRefresh = () => {
        UpdateHistory(dispatch, (props.CardData?.GroupChat ? props.CardData.GroupChat?.ID : (props.CardData.PhoneNumber.replace('+', ''))), [])
        clearContactStatusHirtory(dispatch)
    }

    return (
        <>
            {
                <div className={`d-flex bb-primary-divider-4 p-relative align-center justify-between flex-direction ${IsMobileDevice ? "w-p-100" : ""}`}>
                    <div className={`d-flex align-center w-p-100 ${IsMobileDevice ? " justify-between" : "ml-1"} justify-between`}>
                        <div className='d-flex align-center'>
                            <button className={`d-flex py-1 ml-1 align-center ${!IsMobileDevice ? "h-8" : ""}`} onClick={props.IsSecureChat ? () => { } : openContactInfo}>
                                {IsMobileDevice && <BackMobileIcon onClick={() => { props.BackHandler() }} className={"my-auto"} />}
                                {
                                    Campaign?.ID ? <Tooltip title="Group broadcast" placement="bottom">
                                        <div className="w-6 h-6 d-flex align-center justify-center bg-color-campaign-avator-icon-bg br-50">
                                            <CampainNewIcon />
                                        </div>
                                    </Tooltip> : GroupChat?.ID ?
                                        <Tooltip title="Group Chat" placement="bottom">
                                            <div className="w-6 h-6 d-flex align-center justify-center bg-color-groupchat-avator-icon-bg br-50">
                                                <img src={GroupchatIcon} alt="groupchat icon" />
                                            </div>
                                        </Tooltip> :
                                        <div>
                                            <Avatar Name={Contact?.Name || ""} PhoneNumber={PhoneNumber} Size={50} Index={props.ActiveCardIndex} />
                                        </div>
                                }
                                <div>
                                    <div className="t-align-left">
                                        <div className={`${IsMobileDevice ? "h2" : "h2-regular"} pl-1`} >
                                            <span className='single-line-break-ellipsis'> {
                                                Campaign?.ID ? Campaign?.Name ? Campaign.Name : "Campaign name" : GroupChat?.Name ? UtilityService.trimMessage(GroupChat?.Name, 40) : GroupChat?.PhoneNumbers ? GroupChat?.PhoneNumbers.length + " people " : IsMobileDevice && Contact?.Name.length > 15 ? Contact?.Name.substring(0, 12).replace(/null/g, '') + "..." : UtilityService.trimMessage(Contact?.Name, 30) || MaskedPhoneNumber || UtilityService.maskPhoneNumberOnLength(PhoneNumber)
                                            }
                                            </span>
                                            {(!!Campaign?.ID || !!GroupChat?.ID) && <CampainMsgHistoryEditIcon className='mt-1 groupchat-edit-button pl-1' onClick={handleEditGroupName} />}
                                        </div>
                                    </div>
                                    <div className="d-flex pl-1">
                                        {
                                            !IsMobileDevice && GroupChat?.PhoneNumbers && <GroupChatContactList numbers={GroupChat?.PhoneNumbers} />
                                        }
                                    </div>
                                    {!Campaign?.ID && !GroupChat?.ID && IsMobileDevice && msgType != "secure-chat" && (
                                        <AssignAndStatus
                                            ShowStatus={true}
                                            ShowAssignee={false}
                                            PhoneNumber={PhoneNumber}
                                            CardData={props.CardData}
                                            onStatusPopoverClose={() => {
                                                statusPopoverJustClosedRef.current = true;
                                                setTimeout(() => { statusPopoverJustClosedRef.current = false; }, 0);
                                            }}
                                        />
                                    )}
                                </div>
                            </button>

                            {
                                !props.IsSecureChat && !Campaign?.ID && !GroupChat?.ID && !Contact?.Name && !IsMobileDevice &&
                                <Tooltip title={buttonLabels.ADD_TO_CONTACTS} >
                                    <ImportContactIcon onClick={() => handleEditContact()} className='p-1 c-pointer' />
                                </Tooltip>
                            }
                            {
                                !props.IsSecureChat && !Campaign?.ID && !GroupChat?.ID && (
                                    <button className="pl-1 c-pointer" tabIndex={1} onClick={(e) => { e.preventDefault(); handleRefresh() }}>
                                        {IsMobileDevice ? <BlackRefreshIcon /> : <RefreshIcon />}
                                    </button>
                                )
                            }
                        </div>
                        <div className='d-flex flex-direction-row'>
                            {!props.IsSecureChat && !IsTeamsApp && IsMobileDevice && (!GroupChat?.ID && !Campaign) ? <a href={`tel:${PhoneNumber}`}>
                                <OutGoingCallIcon className="ml-2 pr-2 px-1 c-pointer" />
                            </a> : (!GroupChat?.ID && !Campaign) && IsTeamsApp && !props.IsSecureChat && <div onClick={() => { startCall(PhoneNumber) }}>
                                <OutGoingCallIcon className="ml-2 pr-2 px-1 c-pointer" />
                            </div>
                            }
                            {!Campaign?.ID && !GroupChat?.ID && IsMobileDevice && msgType != "secure-chat" && (IsNewOrgFlow ? UserPlanTracker?.HasTransferChat : PlanMetrics?.HasTransferChat) && <TransforChatIcon className="c-pointer pr-1 " onClick={openTransferChat} />}

                            {
                                !props.IsSecureChat && IsMobileDevice &&
                                <MenuItemRender HorizantelIcon={true} ClassName={"mr-1"} MenuData={optionData} MeetBallIcon={SettingsVertiMobileIcon} />
                            }
                        </div>
                        {!IsMobileDevice && <div className="d-flex align-center justify-between">
                            {
                                !Campaign?.ID && !GroupChat?.ID && !IsMobileDevice && msgType != "secure-chat" &&
                                <div className='mr-1'>
                                    <AssignAndStatus
                                        PhoneNumber={PhoneNumber}
                                        CardData={props.CardData}
                                        ShowAssignee={true}
                                        ShowStatus={true}
                                    />
                                </div>
                            }
                            {!Campaign?.ID && !GroupChat?.ID && !IsMobileDevice && msgType != "secure-chat" && (IsNewOrgFlow ? UserPlanTracker?.HasTransferChat : PlanMetrics?.HasTransferChat) && <ButtonComponent ButtonLabel={'Transfer Chat'} Variant={'primary-btn-small'} OnClick={() => setTransferConversationChat(true)} ClassName=' mr-2 br-50 w-space' />}
                        </div>}
                    </div>

                    {!Campaign?.ID && !GroupChat?.ID && IsMobileDevice && msgType != "secure-chat" && (
                        <AssignAndStatus
                            ShowStatus={false}
                            ShowAssignee={true}
                            PhoneNumber={PhoneNumber}
                            CardData={props.CardData}
                            onStatusPopoverClose={() => {
                                statusPopoverJustClosedRef.current = true;
                                setTimeout(() => { statusPopoverJustClosedRef.current = false; }, 0);
                            }}
                        />
                    )}
                    {/* {showContactInfo &&
                        <div className='w-50 p-absolute t-1 r-4' style={{ zIndex: 1 }}>
                            <ContactInfoComponent
                                CardTitle={Campaign ? pageTitles.CAMPAGIN_CHAT_INFORMATION : GroupChat ? pageTitles.GROUP_CHAT_INFORMATION : pageTitles.CONTACT_INFO}
                                CloseContactInfo={closeContactInfo}
                                ActionsData={props.ActionsData}
                                Contact={Contact ||
                                    {
                                        PhoneNumber: PhoneNumber,
                                        MaskedPhoneNumber: MaskedPhoneNumber,
                                    } as Contact
                                }
                                GroupChatInfo={GroupChat}
                                campaignInfo={Campaign}
                                ActiveCardIndex={props.ActiveCardIndex}
                            />
                        </div>
                    } */}
                </div>
            }
            {
                openEditContact &&
                <ContactView onClose={closeEditContact}
                    show={openEditContact}
                    Contact={Contacts.find(x => x.ID === Contact?.ID) ||
                        {
                            FirstName: "",
                            PhoneNumber: PhoneNumber,
                            MaskedPhoneNumber: MaskedPhoneNumber,
                            IsBlocked: IsBlocked
                        } as Contact
                    }
                />
            }

            {showDeleteHistoryDialog &&
                <ConfirmDialog
                    onClose={closeDeleteHistoryDialog}
                    Show={showDeleteHistoryDialog}
                    Text={appNote.CONVERSATION_DELETE}
                    ButtonName={buttonLabels.DELETE}
                    Loading={isloading}
                />
            }
            {showMuteForm &&
                <Dialog
                    open={showMuteForm}
                    onClose={() => setShowMuteForm(false)}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    classes={{ paper: `w-p-100 br-2 dialogue-shadow` }}
                >
                    <DialogTitle className="p-2">
                        <div className="d-flex justify-between">
                            <span className={`ml-1 h1-semibold`}>
                                {`Mute  ${!!props.CardData.GroupChat?.ID ? props.CardData.GroupChat?.Name ? props.CardData.GroupChat?.Name : "Group Chat" : props.CardData.Contact?.Name ? props.CardData.Contact?.Name : props.CardData.MaskedPhoneNumber}`}
                            </span>
                            <Tooltip title='Close' placement='bottom'>
                                <span><CancelIcon className={"c-pointer ml-auto mr-1"} onClick={() => setShowMuteForm(false)} />
                                </span>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <div className={"bb-primary-background-pink-4 mx-3"}></div>
                    <DialogContent>
                        <DialogContentText className="pt-2 color-conv-hist-menu">
                            <FormControl component="fieldset" fullWidth>
                                <RadioGroup
                                >
                                    {MuteOptions.map((option) => (
                                        <FormControlLabel
                                            value={option.value}
                                            checked={option.value === muteDuration}
                                            control={<Radio />}
                                            label={option.name}
                                            key={option.value}
                                            onClick={(event: any) => event.stopPropagation()}
                                            onChange={(event: any) => {
                                                if (event.target.checked) {
                                                    setMuteDuration(option.value)
                                                }
                                            }}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="pb-2">
                        <ButtonComponent OnClick={() => setShowMuteForm(false)} ButtonLabel={buttonLabels.CANCEL.toUpperCase()} ClassName={"c-pointer"} Variant={"secondary-btn-small"} />
                        <ButtonComponent OnClick={(e: any) => muteConversation(e)} ButtonLabel={ActionLabels.MUTE} ClassName={"c-pointer mr-1 px-4"} Variant={"primary-btn-small"} Loading={isloading} />
                    </DialogActions>
                </Dialog>}
            {
                openEditGroupChatName &&
                <GroupChatViewComponent
                    show={openEditGroupChatName}
                    onClose={handleCloseEditGroupchatname}
                    Groupchat={GroupChat}
                    Campaign={Campaign}
                />
            }
            {
                IsTransferConversationChat &&
                <TransferConversationChat
                    Show={IsTransferConversationChat}
                    HandleCloseTransfer={() => setTransferConversationChat(false)}
                    ContactNumber={PhoneNumber}
                />
            }
        </>
    )
}
export default ConversationHistoryHeader